import React, { lazy, Suspense }  from 'react'
import ReactDOM from 'react-dom'

import Loader from '@components/shared/loader/loader'
const EstimateForm = lazy(() => import('@components/estimate_form/estimate_form'))

document.addEventListener('DOMContentLoaded', () => {
  const elem = document.getElementById('estimate-form-body');

  ReactDOM.render(
    <Suspense fallback={Loader()}>
      <EstimateForm />
    </Suspense>,
    elem
  );
}, { once: true });
